<template>
  <div class="dashboard-week-page">
    <calendar :tasks="tasks" :stickers="stickers" :holidays="holidays" />
  </div>
</template>

<script>
import Calendar from '@/components/dashboard/week-page/calendar'

export default {
  props: ['tasks', 'holidays', 'stickers', 'stats'],
  components: {
    Calendar
  }
}
</script>

<style>
</style>
